<p-dialog
    [(visible)]="visible"
    [modal]="true"
    [draggable]="false"
    [resizable]="false"
    [closeOnEscape]="!modificaInCorso"
    [dismissableMask]="!modificaInCorso"
    [style]="{width: '850px', height: '450px'}"
    styleClass="p-fluid modifica-rendicontazione-dialog"
    [showHeader]="false"
    (onHide)="hide()">

    <div class="dialog-container">
        <div class="dialog-header">
            <div class="header-content">
                <i class="pi pi-pencil header-icon"></i>
                <h3>Modifica {{ rendicontazione?.tipo?.descrizione | uppercase}} dell'intervento </h3>
                <div *ngIf="intervento?.scheda?.vecchioCodiceUmvs" class="code-badge legacy-code" style="background-color: #f0f0f0; padding: 0.25rem 0.5rem; border-radius: 4px; margin-left: 1rem; border-left: 3px solid #8f5cb7;">
                  <span class="code-value" style="font-weight: bold; color: #8B4513; " pTooltip="VECCHIO CODICE UMVS" tooltipPosition="top">{{ intervento?.scheda?.vecchioCodiceUmvs }}</span>
                 </div>
                 <div class="code-badge" style="background-color: #f0f0f0; padding: 0.25rem 0.5rem; border-radius: 4px; margin-left: 1rem; border-left: 3px solid #4285F4;">
                   <span class="code-value" style="font-weight: bold; color: #3a6e75;" pTooltip="NUOVO CODICE" tooltipPosition="top">{{ intervento?.scheda?.codice }}</span>
                 </div>
            </div>
            <button
                pButton
                pRipple
                icon="pi pi-times"
                class="p-button-rounded p-button-text close-btn"
                [disabled]="modificaInCorso"
                (click)="hide()">
            </button>
        </div>

        <div class="dialog-content">
           <!--  <div class="field mt-2">
              <label for="tipoRendicontazione">Tipo Rendicontazione</label>
              <p-dropdown
                  id="tipoRendicontazione"
                  name="tipoRendicontazione"
                  [options]="tipiRendicontazione"
                  [(ngModel)]="tipoRendicontazione"
                  optionLabel="label"
                  placeholder="Seleziona tipo rendicontazione"
                  [disabled]="true"
                  (onChange)="onTipoRendicontazioneChange($event)">
              </p-dropdown>
          </div>
          <div *ngIf="tipoRendicontazione && tipoRendicontazione.value === 'ACCONTO'"
                 class="p-message p-message-warn"
                 style="margin: 1rem 0; padding: 1.25rem; background-color: #fff8e1; border-left: 4px solid #ffc107; border-radius: 4px; box-shadow: 0 2px 4px rgba(0,0,0,0.05);">
                <div style="display: flex; align-items: flex-start;">
                    <i class="pi pi-exclamation-triangle" style="color: #ffc107; font-size: 1rem; margin-right: 0.75rem; margin-top: 0.125rem;"></i>
                    <div>
                        <h4 style="margin: 0 0 0.25rem 0; color: #856404; font-size: 0.875rem; font-weight: 600;">Importante</h4>
                        <p style="margin: 0; color: #666; line-height: 1.4; font-size: 0.875rem;">Per l'acconto è necessario indicare il 50% dell'importo effettivo della spesa se l'intervento ha avuto un costo diverso dall'importo finanziato.</p>
                    </div>
                </div>
            </div> -->
            <form>
                <div class="field-row">
                    <div class="field-left">
                        <label for="importoFinanziato">Importo Finanziato</label>
                        <p-inputNumber
                            id="importoFinanziato"
                            name="importoFinanziato"
                            [ngModel]="intervento?.importoFinanziato"
                            mode="currency"
                            currency="EUR"
                            locale="it-IT"
                            [disabled]="true">
                        </p-inputNumber>
                    </div>
                    <div class="arrow-container">
                        <i class="pi pi-arrow-right" style="font-size: 2rem; color: #6c757d;"></i>
                    </div>
                    <div class="field-right">
                        <label for="importoRendicontato">Importo da Rendicontare</label>
                                                    <p-inputNumber
                                id="importoRendicontato"
                                name="importoRendicontato"
                                [(ngModel)]="importoRendicontato"
                                mode="currency"
                                currency="EUR"
                                locale="it-IT"
                                [min]="0"
                                [max]="intervento?.importoFinanziato"
                                [disabled]="modificaInCorso">
                            </p-inputNumber>
                    </div>
                </div>
            </form>
            <div class="form-container form-container-note">
                <div class="field">
                    <label for="note">Note</label>
                    <textarea
                        id="note"
                        pInputTextarea
                        [(ngModel)]="note"
                        [rows]="3"
                        [disabled]="modificaInCorso"
                        placeholder="Inserisci eventuali note"
                        class="w-full"
                        style="resize: vertical">
                    </textarea>
                </div>
            </div>
        </div>

        <div class="dialog-footer">
            <button
                pButton
                pRipple
                label="Annulla"
                icon="pi pi-times"
                class="p-button-outlined p-button-secondary"
                [disabled]="modificaInCorso"
                (click)="hide()">
            </button>
            <button
                pButton
                pRipple
                [label]="modificaInCorso ? '' : 'Salva Modifiche'"
                [icon]="modificaInCorso ? '' : 'pi pi-check'"
                class="p-button-warning"
                (click)="salvaModifiche()"
                [disabled]="!isFormValid() || modificaInCorso">
                <ng-container *ngIf="modificaInCorso">
                    <i class="pi pi-spin pi-spinner" style="margin-right: 0.5rem;"></i>
                    Salvataggio...
                </ng-container>
            </button>
        </div>
    </div>
</p-dialog>

<p-toast position="top-right"></p-toast>
